export default "__VITE_ASSET__Cv25JP3J__"